/**
 * @description Obtiene el valor de una propiedad anidada en un objeto usando notación de punto
 * @param {Object} obj - Objeto del cual obtener la propiedad
 * @param {string} path - Path de la propiedad en formato de punto (ej: 'person.age')
 * @returns {any} - Valor de la propiedad o undefined si no existe
 */
const getNestedProp = (obj, path) =>
  path.split('.').reduce((current, key) => {
    if (current === undefined || current === null) {
      return undefined;
    }
    return typeof current === 'object' ? current[key] : current;
  }, obj);

export default getNestedProp;
